export default __webpack_public_path__ + "static/media/CurrentHarmonicDistortion.58be7e9e.svg";